module.exports = __webpack_public_path__ + "static/media/LEO.d7e30a3a.svg";